import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { Appointment } from "Types/api/Appointment";
import { History } from "history";
import { API } from "src/store/dataService/types";
import { Person } from "Types/api/Person";

/**
 * Open Test Drive Modal
 */
export const openTestDriveModal = actionCreator(
    "test_drive/ui/open_modal",
    (hasTestDrive: boolean, history: History) => ({
        hasTestDrive,
        history,
    }),
    () => ({ route: API.TestDrive })
);

/**
 * Close Test Drive Modal
 */
export const closeTestDriveModal = actionCreator(
    "test_drive/ui/close_modal",
    (history: History) => ({
        history,
    }),
    () => ({ route: API.TestDrive })
);

/**
 * Reschedule Test Drive
 */
export const rescheduleTestDrive = actionCreator(
    "test_drive/ui/reschedule",
    (history: History) => ({
        history,
    }),
    () => ({ route: API.TestDrive })
);

/**
 * Test Drive POST Request
 */
export const postTestDriveRequest = actionCreator(
    "test_drive/post/request",
    (
        appointment: Appointment,
        history: History,
        person: Partial<Person>,
        setError: (errorMessage: string) => void,
        setLoading: (loading: boolean) => void,
        uuid
    ) => ({
        appointment,
        history,
        person,
        setError,
        setLoading,
        uuid,
    }),
    () => ({ route: API.TestDrive })
);

/**
 * Test Drive POST Success
 */
export const postTestDriveSuccess = actionCreator(
    "test_drive/post/success",
    (appointment: Appointment, history: History, person: Partial<Person>, uuid: string) => ({
        appointment,
        history,
        person,
        uuid,
    }),
    () => ({ route: API.TestDrive })
);

/**
 * Test Drive POST Failure
 */
export const postTestDriveFailure = actionCreator(
    "test_drive/post/failure",
    (setError: (message: string) => void, setLoading: (loading: boolean) => void) => ({
        setError,
        setLoading,
    }),
    () => ({ route: API.TestDrive })
);
